import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_cookieuniversalnuxt_62bdce61 from 'nuxt_plugin_cookieuniversalnuxt_62bdce61' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_sentryserver_49a8b77d from 'nuxt_plugin_sentryserver_49a8b77d' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_38217416 from 'nuxt_plugin_sentryclient_38217416' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_toast_4cb30d68 from 'nuxt_plugin_toast_4cb30d68' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_fefa7e8e from 'nuxt_plugin_axios_fefa7e8e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_globalMixin_2ba03b8f from 'nuxt_plugin_globalMixin_2ba03b8f' // Source: ../plugins/globalMixin.js (mode: 'all')
import nuxt_plugin_axiosConfig_d83436d6 from 'nuxt_plugin_axiosConfig_d83436d6' // Source: ../plugins/axiosConfig.js (mode: 'all')
import nuxt_plugin_routerExtend_d9fa3dc4 from 'nuxt_plugin_routerExtend_d9fa3dc4' // Source: ../plugins/routerExtend.js (mode: 'all')
import nuxt_plugin_globalDirectives_305ae94c from 'nuxt_plugin_globalDirectives_305ae94c' // Source: ../plugins/globalDirectives.js (mode: 'all')
import nuxt_plugin_sentry_e47869fc from 'nuxt_plugin_sentry_e47869fc' // Source: ../plugins/sentry.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"main-page","mode":"out-in","css":true,"appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Music Promotion With Results","link":[{"href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Montserrat:400,500,600,700&display=swap","rel":"stylesheet"},{"href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons","rel":"stylesheet"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fmedia\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Fmedia\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Fmedia\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Fmedia\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fmedia\u002Fsafari-pinned-tab.svg","color":"#eb6345"},{"rel":"shortcut icon","href":"\u002Fmedia\u002Ffavicon.ico"}],"meta":[{"name":"google-site-verification","content":"kFdEo_PfbQZI4AovcULSr-kYEzP-xaqK4YXrSZernrs"},{"name":"keywords","hid":"keywords","content":"Groover,promotion,promouvoir sa musique,musique,influenceurs,radio,label,booker,média,media,webradio,playlist,playlister,promote,influencer,influencers,track,tune,song,music"},{"name":"description","hid":"description","content":"Send your songs to the best music media, blogs, radios, record labels, Spotify playlisters, bookers... Get listened to, feedback guaranteed and coverage"},{"charset":"UTF-8"},{"name":"viewport","hid":"viewport","content":"width=720"},{"property":"og:title","hid":"og:title","content":"Music Promotion With Results"},{"property":"og:image","hid":"og:image","content":"https:\u002F\u002Fgroover.co\u002Fmedia\u002Fgroover-home.jpg"},{"property":"og:description","hid":"og:description","content":"Send your songs to the best music media, blogs, radios, record labels, Spotify playlisters, bookers... Get listened to, feedback guaranteed and coverage"},{"property":"og:type","content":"website"},{"name":"msapplication-TileColor","content":"#eb6345"},{"name":"msapplication-config","content":"\u002Fmedia\u002Fbrowserconfig.xml"},{"name":"theme-color","content":"#ffffff"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_cookieuniversalnuxt_62bdce61 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_62bdce61(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_49a8b77d === 'function') {
    await nuxt_plugin_sentryserver_49a8b77d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_38217416 === 'function') {
    await nuxt_plugin_sentryclient_38217416(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_4cb30d68 === 'function') {
    await nuxt_plugin_toast_4cb30d68(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_fefa7e8e === 'function') {
    await nuxt_plugin_axios_fefa7e8e(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_globalMixin_2ba03b8f === 'function') {
    await nuxt_plugin_globalMixin_2ba03b8f(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosConfig_d83436d6 === 'function') {
    await nuxt_plugin_axiosConfig_d83436d6(app.context, inject)
  }

  if (typeof nuxt_plugin_routerExtend_d9fa3dc4 === 'function') {
    await nuxt_plugin_routerExtend_d9fa3dc4(app.context, inject)
  }

  if (typeof nuxt_plugin_globalDirectives_305ae94c === 'function') {
    await nuxt_plugin_globalDirectives_305ae94c(app.context, inject)
  }

  if (typeof nuxt_plugin_sentry_e47869fc === 'function') {
    await nuxt_plugin_sentry_e47869fc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
